import ApiService from '../../../core/services/ApiService';

export interface UserListItem {
  id: string;
  fullName: string;
  email: string;
  role: string;
  status: string;
  lastActive: string | null;
}

class UserManagementService extends ApiService {
  getUsers(): Promise<UserListItem[]> {
    return this.makeRequest<UserListItem[]>('/api/users', { extractData: true });
  }
}

export const userManagementService = new UserManagementService();
